import { LocationOutline, ChatbubbleOutline, MailOutline } from 'react-ionicons'
import { Image } from '@/components/elements/Image'
import { H2 } from '@/components/elements/Headers'
import { Divider } from '@/components/elements/Divider'
import { IonIcon } from '@/src/icons'

export interface CinemaHeaderProps {
  picture: string
  title: string
  subtitle: string
  location: string
  locationLink?: string
  phone: string
  email: string
}

export const CinemaHeader: React.FC<CinemaHeaderProps> = ({
  picture,
  title,
  subtitle,
  location,
  locationLink,
  phone,
  email,
}) => {
  return (
    <div className="relative w-full">
      <div className="aspect-w-10 aspect-h-10 header-bg-image md:aspect-none w-full min-h-76 md:absolute md:inset-0">
        <Image
          src={picture}
          layout="fill"
          alt={title}
          objectFit="cover"
          className="relative z-0"
        />
      </div>
      <div className="relative z-10 ml-auto md:max-w-md">
        <div className="px-5 py-10 text-white bg-omnium md:p-10 md:min-h-150">
          <H2>{title}</H2>
          <p className="mb-8 mt-4 font-bold">{subtitle}</p>
          <Divider marginless variant="light" className="my-6" />
          <div className="flex items-center font-semibold">
            <IonIcon
              icon={LocationOutline}
              className="mr-3.5 w-6 h-4 text-white"
            />
            {!locationLink && location}
            {locationLink && (
              <a target="_blank" href={locationLink} rel="noreferrer">
                {location}
              </a>
            )}
          </div>
          {phone && (
            <>
              <Divider marginless variant="light" className="my-6" />
              <div className="flex items-center font-semibold">
                <IonIcon
                  icon={ChatbubbleOutline}
                  className="mr-3.5 w-6 h-4 text-white"
                />
                {phone}
              </div>
            </>
          )}
          {email && (
            <>
              <Divider marginless variant="light" className="my-6" />
              <div className="flex items-center font-semibold">
                <IonIcon
                  icon={MailOutline}
                  className="mr-3.5 w-6 h-4 text-white"
                />
                {email}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
